module.exports = __webpack_public_path__ + "PTSans-NarrowBold.780494ab1c3ff68d4aea.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/PTSans-NarrowBold.ttf
// module id = ../../../../../src/assets/customfonts/PTSans-NarrowBold.ttf
// module chunks = styles